'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVideo = function TiVideo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.5 11.9c-0.2-0.1-0.5-0.2-0.8-0.2-0.3 0-0.5 0-0.8 0.1l-4.2 2.2v-0.7c0-2.7-2.3-5-5-5h-18.4c-2.7 0-5 2.3-5 5v13.4c0 2.7 2.3 5 5 5h18.4c2.7 0 5-2.3 5-5v-0.7l4.2 2.2c0.3 0.1 0.5 0.1 0.8 0.1 0.3 0 0.6-0.1 0.8-0.2 0.5-0.3 0.8-0.9 0.8-1.4v-13.4c0-0.5-0.3-1.1-0.8-1.4z m-25.8 10.6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.2 2.5-2.5 2.5z' })
        )
    );
};

exports.default = TiVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/video.js
// module id = 3818
// module chunks = 0